

import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-select-placeholder',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *mwcStringTemplateOutlet="placeholder">
      {{ placeholder }}
    </ng-container>
  `,
  host: { class: 'mwc-select-selection-placeholder' }
})
export class MwcSelectPlaceholderComponent {
  @Input() placeholder: TemplateRef<MwcSafeAny> | string | null = null;

  constructor() {}
}
